<template>
  <div class="page">
    <home-header />
    <main class="landing-page">
      <div class="landing-page__container">
        <home-welcome id="welcome" />
        <home-how-it-works />
        <home-faq/>
      </div>
    </main>
    <landing-footer />
  </div>
</template>

<script>
import HomeHeader from '@/components/Landing/Home/Header.vue'
import HomeFaq from '@/components/Landing/Home/FAQ.vue'
import LandingFooter from '@/components/Landing/Footer.vue'
import HomeWelcome from '../components/Landing/Home/Welcome.vue'
import HomeHowItWorks from '../components/Landing/Home/HowItWorks.vue'

export default {
  name: 'Home',

  components: {
    HomeWelcome,
    HomeHowItWorks,
    HomeFaq,
    HomeHeader,
    LandingFooter
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/style/scss/vars";

.landing-page {
  background-color: $white;
}
</style>
